module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel md-scrollbar md-theme-default",
    attrs: {
      "id": "entities"
    }
  }, [_c('md-content', {
    staticClass: "md-layout-row md-gutter md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('module-menu'), _c('div', {
    staticClass: "md-flex",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('md-table', {
    attrs: {
      "md-theme": "white"
    }
  }, _vm._l((_vm.entities), function(entity) {
    return _c('md-table-row', {
      key: entity.id,
      class: (_vm.$route.params.entity_code && _vm.$route.params.entity_code == entity.code) ? 'entity-row hovered' : 'entity-row'
    }, [_c('md-table-cell', {
      staticClass: "load"
    }, [_c('router-link', {
      staticClass: "small md-primary",
      attrs: {
        "to": {
          name: 'Entity',
          params: {
            code: _vm.$route.params.code,
            entity_code: entity.code
          },
          query: _vm.$route.query
        }
      }
    }, [_c('span', {
      staticClass: "md-layout-row md-gutter"
    }, [_c('span', {
      staticClass: "md-flex name"
    }, [_vm._v(_vm._s(entity.name + ' (' + entity.code + ')'))])])])], 1)], 1)
  }))], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fb28434","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/module/views/Entities.vue
// module id = 1183
// module chunks = 0